(function () {
  function bind(root) {
    root.querySelectorAll("details.mega-menu__nested").forEach(function (el) {
      if (el.dataset.klNestedBound) return;
      el.dataset.klNestedBound = "1";
      el.addEventListener("mouseenter", function () {
        el.setAttribute("open", "");
      });
      el.addEventListener("mouseleave", function () {
        el.removeAttribute("open");
      });
    });
  }
  function run() {
    document.querySelectorAll(".mega-menu").forEach(bind);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  document.addEventListener("shopify:section:load", run);
})();
